module.exports = new __parcel__URL__("US_INC_banner.e526da18.jpg").toString();